export class AdvancedSearch {
    name = '';
    email = '';
    company = '';
    markup: number;
    country: any[] = [];
    manager = '';
    group_id = '';
    reg_date: any;
}



// WEBPACK FOOTER //
// ./src/app/entities/advanced-search.ts